/**
 * @param {*} x
 * @returns {boolean}
 */
function isBool (x) {
  return x !== undefined && x !== null && typeof x === 'boolean'
}

module.exports = { isBool }
